export const downloadBase64Image = (base64Data: string, filename: string) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'image/jpeg' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;

  a.click();

  URL.revokeObjectURL(url);
};

export const downloadFile = (file: File, filename: string) => {
  const url = URL.createObjectURL(file);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;

  a.click();

  URL.revokeObjectURL(url);
};

export const createFileFromUrl = async (url, fileName) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], fileName, { type: blob.type });
  return file;
};

export const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const getFileVehiculeImportHeader = () => [
  'Brand',
  'Model',
  'VIN',
  'LicensePlateNumber',
  'YearOfFirstRegistration',
  'Mileage',
  'Comment',
  'Picture',
];

export const getFileLineExampleVehicule = () => [
  'Peugeot',
  '208',
  'VF3YB9HP0JT123456',
  'AB-123-CD',
  '2020',
  '35000',
  'Comment',
  'https://images.pexels.com/photos/170811/pexels-photo-170811.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
];

export const downloadTemplateVehiculeImport = () => {
  const headers = getFileVehiculeImportHeader();
  const example = getFileLineExampleVehicule();
  const csv = [headers.join(','), example.join(',')].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', 'import-vehicule-model.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
